export default () => ({
  echo: {},
  excludeId: null,
});
